import { useState } from 'react';
import TopNavbar from '../../components/ui/TopNavbar';
import Sidebar, { SidebarProvider, useSidebar } from '../../components/ui/Sidebar';

import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ShipmentFilters from './components/ShipmentFilters';
import ShipmentDataGrid from './components/ShipmentDataGrid';
import ShipmentDetailsPanel from './components/ShipmentDetailsPanel';
import BulkActionToolbar from './components/BulkActionToolbar';
import AddShipmentModal from './components/AddShipmentModal';

const ShipmentRegister = () => {
  const { isCollapsed } = useSidebar();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [showDetailsPanel, setShowDetailsPanel] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddModal, setShowAddModal] = useState(false);
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 20;

  const mockShipments = [
    {
      id: 1,
      vesselName: "Pacific Glory",
      supplier: "Whitehaven Coal",
      buyer: "Adani Power Limited",
      tonnage: 320000,
      coalGrade: "NAR 6300",
      laycanFrom: "2025-12-15",
      laycanTo: "2025-12-25",
      etd: "2025-12-18",
      eta: "2026-01-05",
      pricingWindow: "M+1 Average",
      lcStatus: "received",
      status: "loading",
      contractRef: "WH-AP-2025-001",
      incoterm: "FOB Newcastle",
      port: "Port of Newcastle",
      basePrice: 145.50,
      discount: 2.5,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 2,
      vesselName: "Ocean Harmony",
      supplier: "Yancoal Australia",
      buyer: "NTPC Limited",
      tonnage: 150000,
      coalGrade: "NAR 6000",
      laycanFrom: "2025-12-20",
      laycanTo: "2025-12-30",
      etd: "2025-12-22",
      eta: "2026-01-08",
      pricingWindow: "M+2 Average",
      lcStatus: "received",
      status: "in-transit",
      contractRef: "YC-NT-2025-002",
      incoterm: "FOB Gladstone",
      port: "Port of Gladstone",
      basePrice: 142.75,
      discount: 3.0,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 3,
      vesselName: "Star Navigator",
      supplier: "Glencore Coal Assets",
      buyer: "Tata Power Company",
      tonnage: 380000,
      coalGrade: "NAR 6500",
      laycanFrom: "2026-01-05",
      laycanTo: "2026-01-15",
      etd: "2026-01-08",
      eta: "2026-01-25",
      pricingWindow: "M+1 Average",
      lcStatus: "pending",
      status: "contract-signed",
      contractRef: "GL-TP-2025-003",
      incoterm: "FOB Newcastle",
      port: "Port of Newcastle",
      basePrice: 148.25,
      discount: 2.0,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 4,
      vesselName: "Maritime Express",
      supplier: "Peabody Energy Australia",
      buyer: "JSW Energy Limited",
      tonnage: 265000,
      coalGrade: "NAR 5800",
      laycanFrom: "2026-01-10",
      laycanTo: "2026-01-20",
      etd: "2026-01-12",
      eta: "2026-01-28",
      pricingWindow: "M+2 Average",
      lcStatus: "received",
      status: "lc-received",
      contractRef: "PE-JS-2025-004",
      incoterm: "FOB Hay Point",
      port: "Hay Point",
      basePrice: 138.90,
      discount: 3.5,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 5,
      vesselName: "Global Trader",
      supplier: "Whitehaven Coal",
      buyer: "Adani Power Limited",
      tonnage: 185000,
      coalGrade: "NAR 6200",
      laycanFrom: "2026-01-15",
      laycanTo: "2026-01-25",
      etd: "2026-01-18",
      eta: "2026-02-03",
      pricingWindow: "M+1 Average",
      lcStatus: "pending",
      status: "contract-signed",
      contractRef: "WH-AP-2025-005",
      incoterm: "FOB Newcastle",
      port: "Port of Newcastle",
      basePrice: 146.80,
      discount: 2.5,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 6,
      vesselName: "Horizon Voyager",
      supplier: "Yancoal Australia",
      buyer: "NTPC Limited",
      tonnage: 340000,
      coalGrade: "NAR 6100",
      laycanFrom: "2025-11-20",
      laycanTo: "2025-11-30",
      etd: "2025-11-22",
      eta: "2025-12-08",
      pricingWindow: "M+2 Average",
      lcStatus: "received",
      status: "discharged",
      contractRef: "YC-NT-2025-006",
      incoterm: "FOB Gladstone",
      port: "Port of Gladstone",
      basePrice: 143.50,
      discount: 3.0,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 7,
      vesselName: "Neptune Star",
      supplier: "Glencore Coal Assets",
      buyer: "Tata Power Company",
      tonnage: 225000,
      coalGrade: "NAR 6400",
      laycanFrom: "2025-11-10",
      laycanTo: "2025-11-20",
      etd: "2025-11-12",
      eta: "2025-11-28",
      pricingWindow: "M+1 Average",
      lcStatus: "received",
      status: "completed",
      contractRef: "GL-TP-2025-007",
      incoterm: "FOB Newcastle",
      port: "Port of Newcastle",
      basePrice: 147.90,
      discount: 2.0,
      plattsIndex: "Newcastle 6000 NAR"
    },
    {
      id: 8,
      vesselName: "Coastal Pride",
      supplier: "Peabody Energy Australia",
      buyer: "JSW Energy Limited",
      tonnage: 420000,
      coalGrade: "NAR 5900",
      laycanFrom: "2026-01-20",
      laycanTo: "2026-01-30",
      etd: "2026-01-22",
      eta: "2026-02-07",
      pricingWindow: "M+2 Average",
      lcStatus: "pending",
      status: "contract-signed",
      contractRef: "PE-JS-2025-008",
      incoterm: "FOB Hay Point",
      port: "Hay Point",
      basePrice: 139.75,
      discount: 3.5,
      plattsIndex: "Newcastle 6000 NAR"
    }
  ];

  const handleFilterChange = (filters) => {
    console.log('Filters applied:', filters);
    // TODO: Implement actual filter logic with backend
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handleClearFilters = () => {
    console.log('Filters cleared');
    // TODO: Reset filters and reload data
  };

  const handleRowSelect = (ids) => {
    setSelectedRows(ids);
  };

  const handleRowExpand = (id) => {
    setExpandedRows(prev =>
      prev?.includes(id) ? prev?.filter(rowId => rowId !== id) : [...prev, id]
    );
  };

  const handleViewDetails = (shipment) => {
    setSelectedShipment(shipment);
    setShowDetailsPanel(true);
  };

  const handleCloseDetails = () => {
    setShowDetailsPanel(false);
    setSelectedShipment(null);
  };

  const handleUpdateShipment = (updatedData) => {
    console.log('Shipment updated:', updatedData);
    // TODO: Implement actual update with Supabase
    alert('✅ Shipment updated successfully!');
  };

  const handleBulkAction = (action, data) => {
    console.log('Bulk action:', action, data);
    // TODO: Implement bulk operations
    const actionMessages = {
      'update-status': `✅ Status updated for ${selectedRows?.length} shipments`,
      'export': `✅ Exported ${selectedRows?.length} shipments`,
      'delete': `✅ Deleted ${selectedRows?.length} shipments`,
    };
    alert(actionMessages?.[action] || '✅ Action completed');
    setSelectedRows([]);
  };

  const handleExport = (format) => {
    console.log('Exporting as:', format);
    // TODO: Implement actual export functionality
    const formatNames = {
      excel: 'Excel',
      pdf: 'PDF',
      csv: 'CSV'
    };
    alert(`✅ Exporting ${mockShipments?.length} shipments as ${formatNames?.[format]}...`);
  };

  const handleAddShipment = () => {
    setShowAddModal(true);
  };

  const handleSaveNewShipment = (newShipmentData) => {
    console.log('New shipment:', newShipmentData);
    // TODO: Implement actual save with Supabase
    alert('✅ New shipment added successfully!');
    setShowAddModal(false);
  };

  const totalPages = Math.ceil(mockShipments?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentShipments = mockShipments?.slice(startIndex, endIndex);

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden mt-[65px]">
        {/* Mobile-optimized header */}
        <header className="bg-card border-b border-border px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-[65px] z-20">
          <div className="flex flex-col gap-3 sm:gap-4">
            {/* Title row - mobile stacked */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground truncate">
                  Shipment Register
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-2">
                  Comprehensive shipment lifecycle management from contract to delivery
                </p>
              </div>
              
              {/* Action buttons - responsive layout */}
              <div className="flex items-center gap-2 flex-wrap">
                <div className="flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 bg-muted/50 rounded-lg">
                  <Icon name="Database" size={14} color="var(--color-primary)" className="flex-shrink-0" />
                  <span className="text-xs sm:text-sm font-medium text-foreground whitespace-nowrap">
                    {mockShipments?.length} Total
                  </span>
                </div>
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  onClick={handleAddShipment}
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Add Shipment</span>
                  <span className="sm:hidden">Add</span>
                </Button>
              </div>
            </div>

            {/* Export buttons row - mobile scrollable */}
            <div className="flex items-center gap-2 sm:gap-3 overflow-x-auto pb-2 -mx-3 px-3 sm:mx-0 sm:px-0 no-scrollbar">
              <div className="flex items-center gap-2 flex-shrink-0">
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Download"
                  iconPosition="left"
                  onClick={() => handleExport('excel')}
                  className="text-xs whitespace-nowrap min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Export Excel</span>
                  <span className="sm:hidden">Excel</span>
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="FileText"
                  iconPosition="left"
                  onClick={() => handleExport('pdf')}
                  className="text-xs whitespace-nowrap min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Export PDF</span>
                  <span className="sm:hidden">PDF</span>
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="FileSpreadsheet"
                  iconPosition="left"
                  onClick={() => handleExport('csv')}
                  className="text-xs whitespace-nowrap min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Export CSV</span>
                  <span className="sm:hidden">CSV</span>
                </Button>
              </div>
              
              {/* Mobile filter toggle */}
              <Button
                variant="outline"
                size="sm"
                iconName="Filter"
                iconPosition="left"
                onClick={() => setShowFilters(!showFilters)}
                className="lg:hidden text-xs whitespace-nowrap min-h-[44px] sm:min-h-auto"
              >
                Filters
              </Button>
              
              <div className="flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 bg-green-100 dark:bg-green-900/30 rounded-lg flex-shrink-0">
                <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-500 rounded-full animate-pulse flex-shrink-0" />
                <span className="text-[10px] sm:text-xs font-medium text-green-700 dark:text-green-400 whitespace-nowrap">
                  <span className="hidden sm:inline">Real-time Updates Active</span>
                  <span className="sm:hidden">Live</span>
                </span>
              </div>
            </div>
          </div>
        </header>

        {/* Main content area - responsive layout */}
        <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
          {/* Filters sidebar - mobile collapsible */}
          <div className={`
            ${showFilters ? 'block' : 'hidden'} lg:block
            w-full lg:w-80 flex-shrink-0 
            overflow-y-auto custom-scrollbar
            border-b lg:border-b-0 lg:border-r border-border
            max-h-[50vh] lg:max-h-none
          `}>
            <ShipmentFilters
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
            />
          </div>

          {/* Data grid section */}
          <div className="flex-1 flex flex-col overflow-hidden p-3 sm:p-4 md:p-6">
            <BulkActionToolbar
              selectedCount={selectedRows?.length}
              onClearSelection={() => setSelectedRows([])}
              onBulkAction={handleBulkAction}
            />

            <div className="flex-1 overflow-x-auto overflow-y-auto custom-scrollbar -mx-3 sm:mx-0">
              <div className="min-w-[800px] px-3 sm:px-0">
                <ShipmentDataGrid
                  shipments={currentShipments}
                  onRowSelect={handleRowSelect}
                  onRowExpand={handleRowExpand}
                  selectedRows={selectedRows}
                  expandedRows={expandedRows}
                />
              </div>
            </div>

            {/* Pagination - mobile optimized */}
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 pt-4 border-t border-border">
              <div className="text-xs sm:text-sm text-muted-foreground text-center sm:text-left">
                Showing {startIndex + 1} to {Math.min(endIndex, mockShipments?.length)} of {mockShipments?.length}
              </div>
              <div className="flex items-center gap-2 flex-wrap justify-center">
                <Button
                  variant="outline"
                  size="sm"
                  iconName="ChevronLeft"
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                  className="text-xs min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Previous</span>
                  <span className="sm:hidden">Prev</span>
                </Button>
                
                {/* Page numbers - show fewer on mobile */}
                <div className="flex items-center gap-1 max-w-[200px] sm:max-w-none overflow-x-auto no-scrollbar">
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    ?.filter(page => {
                      // On mobile, show only current page +/- 1
                      if (window.innerWidth < 640) {
                        return Math.abs(page - currentPage) <= 1;
                      }
                      return true;
                    })
                    ?.map(page => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-2.5 sm:px-3 py-1.5 rounded text-xs sm:text-sm font-medium transition-colors min-h-[44px] sm:min-h-auto flex items-center justify-center ${
                          currentPage === page
                            ? 'bg-primary text-primary-foreground'
                            : 'text-muted-foreground hover:bg-accent/10'
                        }`}
                      >
                        {page}
                      </button>
                    ))}
                </div>
                
                <Button
                  variant="outline"
                  size="sm"
                  iconName="ChevronRight"
                  onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                  className="text-xs min-h-[44px] sm:min-h-auto"
                >
                  Next
                </Button>
              </div>
            </div>
          </div>

          {/* Details panel - mobile as modal on small screens */}
          {showDetailsPanel && (
            <>
              {/* Mobile backdrop */}
              <div 
                className="lg:hidden fixed inset-0 bg-black/50 z-30"
                onClick={handleCloseDetails}
              />
              
              {/* Panel */}
              <div className={`
                fixed lg:relative
                inset-x-0 bottom-0 lg:inset-auto
                w-full lg:w-96 
                max-h-[80vh] lg:max-h-none
                flex-shrink-0 
                overflow-y-auto custom-scrollbar
                bg-card lg:bg-transparent
                rounded-t-2xl lg:rounded-none
                z-40 lg:z-auto
              `}>
                <ShipmentDetailsPanel
                  shipment={selectedShipment}
                  onClose={handleCloseDetails}
                  onUpdate={handleUpdateShipment}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <AddShipmentModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSave={handleSaveNewShipment}
      />
    </div>
  );
};

export default ShipmentRegister;